import React from "react";

import { AVAILABLE_LANGS } from "@typings/globals";
import { ANCHOR_IDS } from "@typings/anchorIds";

import { Container } from "@components/Layout/Container";
import { CSSGrid } from "@components/Layout/CssGrid";

import * as Styled from "./Hero.styled";
import { selectorAreas, titleAreas } from "./Hero.grids";
import { Image } from "./Image";

interface Props {
  language: AVAILABLE_LANGS;
}

export const Hero: React.FC<Props> = props => {
  return (
    <Styled.Root id={ANCHOR_IDS.BOOK_CLEANING}>
      <Container>
        <CSSGrid areas={titleAreas} />
      </Container>

      <Container>
        <CSSGrid
          areas={selectorAreas}
          areasProps={{ Selector: { language: props.language } }}
        />
      </Container>

      <Image />
    </Styled.Root>
  );
};
